import React, { useContext } from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import Login from "../components/login/Login";
import AgreementConfirm from "../components/agreement/AgreementConfirm";
import AgreementCancel from "../components/agreement/AgreementCancel";
import { MainContext } from "../context/MainContext";
import { DemandRequest } from "../components/demand/DemandRequest";

function PublicRoutes() {
  const { setDataToast, setIsLoading } = useContext(MainContext);

  return (
    <>
      <Routes>
        <Route path="/login" exact element={<Login />} />
        <Route
          path="/solicitud-baja/:tipoSolicitudId"
          element={
            <DemandRequest
              setIsLoading={setIsLoading}
              setDataToast={setDataToast}
            />
          }
        />

        <Route
          path="/contrato/:hash/confirmar"
          element={
            <AgreementConfirm
              setIsLoading={setIsLoading}
              setDataToast={setDataToast}
            />
          }
        />
        <Route
          path="/contrato/cancelar"
          exact
          element={
            <AgreementCancel
              setIsLoading={setIsLoading}
              setDataToast={setDataToast}
            />
          }
        />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
}

export default PublicRoutes;
